import React from "react";
import {
  Factory,
  Handshake,
  Cpu,
  Globe2,
  Sparkles,
} from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const StatItem = ({ Icon, value, label, testId }) => (
  <div
    data-testid={testId}
    className="flex items-center gap-4 min-w-[180px] sm:min-w-0"
  >
    <Icon
      size={48}
      strokeWidth={1.4}
      className="text-neutral-900 shrink-0"
      aria-hidden
    />
    <div>
      <div className="text-2xl sm:text-3xl font-extrabold text-neutral-900 leading-none font-display">
        {value}
      </div>
      <div className="mt-1.5 text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-neutral-700 leading-tight max-w-[140px]">
        {label}
      </div>
    </div>
  </div>
);

const StatsBar = () => {
  const { t } = useLang();
  const items = [
    { Icon: Factory, ...t.stats.experience, testId: "stat-experience" },
    { Icon: Handshake, ...t.stats.employees, testId: "stat-partners" },
    { Icon: Cpu, ...t.stats.machines, testId: "stat-machines" },
    { Icon: Globe2, ...t.stats.countries, testId: "stat-countries" },
    { Icon: Sparkles, ...t.stats.satisfaction, testId: "stat-satisfaction" },
  ];

  return (
    <section data-testid="stats-bar" className="bg-neutral-100">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-8 sm:py-10">
        <div
          className="flex gap-8 sm:gap-4 lg:gap-6 overflow-x-auto no-scrollbar lg:overflow-visible
                     lg:grid lg:grid-cols-5 items-center justify-between"
        >
          {items.map((it, idx) => (
            <StatItem key={idx} {...it} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
